/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ displayHeight: NonNullable<unknown> }} Input_Position_Y_Dialog_TextInputs */

const en_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Enter a value between 1 and ${i?.displayHeight}:`)
};

const fr_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Entrez une valeur entre 1 et ${i?.displayHeight} :`)
};

const de_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Geben Sie einen Wert zwischen 1 und ${i?.displayHeight} ein:`)
};

const it_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Inserisci un valore compreso tra 1 e ${i?.displayHeight}:`)
};

const ru_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Введите значение от 1 до ${i?.displayHeight}:`)
};

const es_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Introduzca un valor entre 1 y ${i?.displayHeight}:`)
};

const zh_cn2_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`请输入介于 1 和 ${i?.displayHeight} 之间的值：`)
};

const ja_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 から ${i?.displayHeight} までの値を入力してください:`)
};

const hi_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`1 और ${i?.displayHeight} के बीच कोई मान दर्ज करें:`)
};

const pt_pt2_input_position_y_dialog_text = /** @type {(inputs: Input_Position_Y_Dialog_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Insira um valor entre 1 e ${i?.displayHeight}:`)
};

/**
* | output |
* | --- |
* | "Enter a value between 1 and {displayHeight}:" |
*
* @param {Input_Position_Y_Dialog_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_y_dialog_text = /** @type {((inputs: Input_Position_Y_Dialog_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_Y_Dialog_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_input_position_y_dialog_text(inputs)
	if (locale === "de") return de_input_position_y_dialog_text(inputs)
	if (locale === "it") return it_input_position_y_dialog_text(inputs)
	if (locale === "ru") return ru_input_position_y_dialog_text(inputs)
	if (locale === "es") return es_input_position_y_dialog_text(inputs)
	if (locale === "zh-CN") return zh_cn2_input_position_y_dialog_text(inputs)
	if (locale === "ja") return ja_input_position_y_dialog_text(inputs)
	if (locale === "hi") return hi_input_position_y_dialog_text(inputs)
	if (locale === "pt-PT") return pt_pt2_input_position_y_dialog_text(inputs)
	return en_input_position_y_dialog_text(inputs)
});